import { Fragment, lazy, useContext } from 'react';
import { Routes, Route, Outlet, Navigate } from 'react-router-dom';
import UserContext from './context/UserContext';

import AdminPageLayout from './components/layout/AdminPageLayout';

const NotFoundPage = lazy(() => import('./pages/404'));
import Login from './pages/Login';

const StringsIndex = lazy(() => import('./pages/strings/Index'));

const UsersIndex = lazy(() => import('./pages/users/Index'));
const UserEdit = lazy(() => import('./pages/users/Edit'));

const BlogsIndex = lazy(() => import('./pages/blogs/Index'));
const BlogEdit = lazy(() => import('./pages/blogs/Edit'));

import StoresIndex from './pages/stores/Index';
const StoreEdit = lazy(() => import('./pages/stores/Edit'));

import OffersIndex from './pages/offers/Index';
const OfferEdit = lazy(() => import('./pages/offers/Edit'));

import OrdersIndex from './pages/orders/Index';
const OrderEdit = lazy(() => import('./pages/orders/Edit'));

import TransactionsIndex from './pages/transactions/Index';
const TransactionEdit = lazy(() => import('./pages/transactions/Edit'));

import CategoriesIndex from './pages/categories/Index';
const CategoryEdit = lazy(() => import('./pages/categories/Edit'));

const Support = lazy(() => import('./pages/Support'));
const Settings = lazy(() => import('./pages/Settings'));

const MenusIndex = lazy(() => import('./pages/menus/Index'));
const MenusEdit = lazy(() => import('./pages/menus/Edit'));

const MenuitemsIndex = lazy(() => import('./pages/menuitems/Index'));
const MenuitemsEdit = lazy(() => import('./pages/menuitems/Edit'));

const CPAIndex = lazy(() => import('./pages/cpa/Index'));
const CPAEdit = lazy(() => import('./pages/cpa/Edit'));

const LoggingIndex = lazy(() => import("./pages/logging/Index"));

const CPADataIndex = lazy(() => import('./pages/cpadata/Index'));
const CPADataEdit = lazy(() => import('./pages/cpadata/Edit'));

import PagesIndex from './pages/pages/Index';
const PageEdit = lazy(() => import('./pages/pages/Edit'));

const RegionsIndex = lazy(() => import('./pages/regions/Index'));
const RegionEdit = lazy(() => import('./pages/regions/Edit'));

const RegiongroupsIndex = lazy(() => import('./pages/regiongroups/Index'));
const RegiongroupEdit = lazy(() => import('./pages/regiongroups/Edit'));

const DomainSettingsIndex = lazy(() => import('./pages/domain-settings/Index'));

import TargetActionsIndex from './pages/target_actions/Index';
import VisitsIndex from './pages/visits/Index';

import LogKeyListener from './components/layout/LogKeyListener'
const LogsIndex = lazy(() => import('./pages/Logs'));

export default function RouteList({ isauth }) {
  const { user } = useContext(UserContext);

  return (
    <Fragment>
      <LogKeyListener />
      <Routes>
        <Route path="/" element={<Outlet />}>
          <Route path="/login" element={!isauth ? <Login /> : <Navigate to="/" replace />} />
          <Route element={<AdminPageLayout />}>
            <Route path="/" element={isauth ? <Navigate to={['admin', 'moder', 'editor'].includes(user.role) ? '/pages' : '/offers'} replace /> : <Navigate to="/login" replace />} />

            {['admin'].includes(user.role) && <Route path="users" element={isauth ? <UsersIndex /> : <Navigate to="/login" replace />} />}
            {['admin'].includes(user.role) && <Route path="users/add" element={isauth ? <UserEdit /> : <Navigate to="/login" replace />} />}
            {['admin'].includes(user.role) && <Route path="user/:id" element={isauth ? <UserEdit /> : <Navigate to="/login" replace />} />}

            <Route path="support" element={isauth ? <Support /> : <Navigate to="/login" replace />} />
            <Route path="settings" element={isauth ? <Settings /> : <Navigate to="/login" replace />} />

            <Route path="target_actions" element={isauth ? <TargetActionsIndex /> : <Navigate to="/login" replace />} />
            <Route path="visits" element={isauth ? <VisitsIndex /> : <Navigate to="/login" replace />} />

            <Route path="stores" element={isauth ? <StoresIndex /> : <Navigate to="/login" replace />} />
            <Route path="stores/add" element={isauth ? <StoreEdit /> : <Navigate to="/login" replace />} />
            <Route path="stores/add/:lang_code/:orig_id" element={isauth ? <StoreEdit /> : <Navigate to="/login" replace />} />
            <Route path="stores/add/:lang_code" element={isauth ? <StoreEdit /> : <Navigate to="/login" replace />} />
            <Route path="store/:id" element={isauth ? <StoreEdit /> : <Navigate to="/login" replace />} />

            <Route path="offers" element={isauth ? <OffersIndex /> : <Navigate to="/login" replace />} />
            <Route path="offers/add" element={isauth ? <OfferEdit /> : <Navigate to="/login" replace />} />
            <Route path="offers/add/:lang_code/:orig_id" element={isauth ? <OfferEdit /> : <Navigate to="/login" replace />} />
            <Route path="offers/add/:lang_code" element={isauth ? <OfferEdit /> : <Navigate to="/login" replace />} />
            <Route path="offer/:id" element={isauth ? <OfferEdit /> : <Navigate to="/login" replace />} />

            {['admin'].includes(user.role) && <Route path="orders" element={isauth ? <OrdersIndex /> : <Navigate to="/login" replace />} />}
            {['admin'].includes(user.role) && <Route path="orders/add" element={isauth ? <OrderEdit /> : <Navigate to="/login" replace />} />}
            {['admin'].includes(user.role) && <Route path="order/:id" element={isauth ? <OrderEdit /> : <Navigate to="/login" replace />} />}

            {['admin'].includes(user.role) && <Route path="transactions" element={isauth ? <TransactionsIndex /> : <Navigate to="/login" replace />} />}
            {['admin'].includes(user.role) && <Route path="transactions/add" element={isauth ? <TransactionEdit /> : <Navigate to="/login" replace />} />}
            {['admin'].includes(user.role) && <Route path="transaction/:id" element={isauth ? <TransactionEdit /> : <Navigate to="/login" replace />} />}

            <Route path="categories" element={isauth ? <CategoriesIndex /> : <Navigate to="/login" replace />} />
            <Route path="categories/add" element={isauth ? <CategoryEdit /> : <Navigate to="/login" replace />} />
            <Route path="categories/add/:lang_code/:orig_id" element={isauth ? <CategoryEdit /> : <Navigate to="/login" replace />} />
            <Route path="categories/add/:lang_code" element={isauth ? <CategoryEdit /> : <Navigate to="/login" replace />} />
            <Route path="category/:id" element={isauth ? <CategoryEdit /> : <Navigate to="/login" replace />} />

            <Route path="blogs" element={isauth ? <BlogsIndex /> : <Navigate to="/login" replace />} />
            <Route path="blogs/add" element={isauth ? <BlogEdit /> : <Navigate to="/login" replace />} />
            <Route path="blogs/add/:lang_code/:orig_id" element={isauth ? <BlogEdit /> : <Navigate to="/login" replace />} />
            <Route path="blogs/add/:lang_code" element={isauth ? <BlogEdit /> : <Navigate to="/login" replace />} />
            <Route path="blog/:id" element={isauth ? <BlogEdit /> : <Navigate to="/login" replace />} />

            {['admin', 'moder', 'editor'].includes(user.role) && <Route path="strings-admin" element={isauth ? <StringsIndex type="strings-admin" /> : <Navigate to="/login" replace />} />}
            {['admin', 'moder', 'editor'].includes(user.role) && <Route path="strings-front" element={isauth ? <StringsIndex type="strings-front" /> : <Navigate to="/login" replace />} />}

            {['admin', 'moder', 'editor'].includes(user.role) && <Route path="pages" element={isauth ? <PagesIndex /> : <Navigate to="/login" replace />} />}
            {['admin', 'moder', 'editor'].includes(user.role) && <Route path="pages/add" element={isauth ? <PageEdit /> : <Navigate to="/login" replace />} />}
            {['admin', 'moder', 'editor'].includes(user.role) && <Route path="pages/add/:lang_code/:orig_id" element={isauth ? <PageEdit /> : <Navigate to="/login" replace />} />}
            {['admin', 'moder', 'editor'].includes(user.role) && <Route path="pages/add/:lang_code" element={isauth ? <PageEdit /> : <Navigate to="/login" replace />} />}
            {['admin', 'moder', 'editor'].includes(user.role) && <Route path="page/:id" element={isauth ? <PageEdit /> : <Navigate to="/login" replace />} />}

            {['admin', 'moder', 'editor'].includes(user.role) && <Route path="frontend/menus" element={isauth ? <MenusIndex /> : <Navigate to="/login" replace />} />}
            {['admin', 'moder', 'editor'].includes(user.role) && <Route path="frontend/menu/add" element={isauth ? <MenusEdit /> : <Navigate to="/login" replace />} />}
            {['admin', 'moder', 'editor'].includes(user.role) && <Route path="frontend/menu/add/:lang_code" element={isauth ? <MenusEdit /> : <Navigate to="/login" replace />} />}
            {['admin', 'moder', 'editor'].includes(user.role) && <Route path="frontend/menu/add/:lang_code/:orig_id" element={isauth ? <MenusEdit /> : <Navigate to="/login" replace />} />}
            {['admin', 'moder', 'editor'].includes(user.role) && <Route path="frontend/menu/:id" element={isauth ? <MenusEdit /> : <Navigate to="/login" replace />} />}

            {['admin', 'moder', 'editor'].includes(user.role) && <Route path="frontend/menuitems/:menu_id" element={isauth ? <MenuitemsIndex /> : <Navigate to="/login" replace />} />}
            {['admin', 'moder', 'editor'].includes(user.role) && <Route path="frontend/menuitem/add/:menu_id" element={isauth ? <MenuitemsEdit /> : <Navigate to="/login" replace />} />}
            {['admin', 'moder', 'editor'].includes(user.role) && <Route path="frontend/menuitem/:id" element={isauth ? <MenuitemsEdit /> : <Navigate to="/login" replace />} />}


            {['admin'].includes(user.role) && <Route path="cpa" element={isauth ? <CPAIndex /> : <Navigate to="/login" replace />} />}
            {['admin'].includes(user.role) && <Route path="cpa/add" element={isauth ? <CPAEdit /> : <Navigate to="/login" replace />} />}
            {['admin'].includes(user.role) && <Route path="cpa/:id" element={isauth ? <CPAEdit /> : <Navigate to="/login" replace />} />}

            {['admin'].includes(user.role) && <Route path="logging" element={isauth ? <LoggingIndex /> : <Navigate to="/login" replace />} />}

            {['admin', 'moder', 'editor'].includes(user.role) && <Route path="cpadata" element={isauth ? <CPADataIndex /> : <Navigate to="/login" replace />} />}
            {['admin', 'moder', 'editor'].includes(user.role) && <Route path="cpadata/:id" element={isauth ? <CPADataEdit /> : <Navigate to="/login" replace />} />}

            {['admin', 'moder', 'editor'].includes(user.role) && <Route path="regions" element={isauth ? <RegionsIndex /> : <Navigate to="/login" replace />} />}
            {['admin', 'moder', 'editor'].includes(user.role) && <Route path="regions/add" element={isauth ? <RegionEdit /> : <Navigate to="/login" replace />} />}
            {['admin', 'moder', 'editor'].includes(user.role) && <Route path="region/:id" element={isauth ? <RegionEdit /> : <Navigate to="/login" replace />} />}

            {['admin', 'moder', 'editor'].includes(user.role) && <Route path="regiongroups" element={isauth ? <RegiongroupsIndex /> : <Navigate to="/login" replace />} />}
            {['admin', 'moder', 'editor'].includes(user.role) && <Route path="regiongroups/add" element={isauth ? <RegiongroupEdit /> : <Navigate to="/login" replace />} />}
            {['admin', 'moder', 'editor'].includes(user.role) && <Route path="regiongroup/:id" element={isauth ? <RegiongroupEdit /> : <Navigate to="/login" replace />} />}

            {['admin', 'moder', 'editor'].includes(user.role) && <Route path="frontend/domain-settings" element={isauth ? <DomainSettingsIndex /> : <Navigate to="/login" replace />} />}

            {['admin'].includes(user.role) && <Route path="logs" element={isauth ? <LogsIndex /> : <Navigate to="/login" replace />} />}
            <Route path="*" element={isauth ? <NotFoundPage /> : <Navigate to="/login" replace />} />
          </Route>
        </Route>
      </Routes>
    </Fragment>
  );
}